<template>
  <div>
    <v-data-table
      v-bind="this.$attrs"
      loading-text="Đang Tải"
      item-key="id"
      :headers="headers"
      :items="studentMenus"
      :loading="loading"
      no-data-text="Không có dữ liệu"
      :footer-props="{
        'items-per-page-text': 'Hiển thị mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page-options': studentMenus.length > 100 ? [10, 20, 30] : [5, 15, -1]
      }"
    >
      <template v-slot:[`item.dob`]="{ item }">
        {{ item.student.dob | ddmmyyyy }}
      </template>
      <template v-slot:[`item.class`]="{ item }">
        <router-link style="text-decoration: none" :to="'/class/' + $_get(item, 'student.currentClass.id')">
          <span>{{ $_get(item, 'student.currentClass.title') }}</span>
        </router-link>
      </template>
      <template v-slot:[`item.student`]="{ item }">
        <CardStudentName :student="item.student" link />
      </template>
      <template v-slot:[`item.selectedMenu`]="{ item }">
        <v-chip small label :color="getStatusSelectedMenu($_get(item, 'studentMenu.selectedMenu'))">
          <div>
            <span class="pr-1 white--text">{{ $_get(item, 'studentMenu.selectedMenu') | selectedMenu }}</span>
          </div>
        </v-chip>
      </template>
      <template v-slot:[`item.registedAmount`]="{ item }">
        <div v-if="$_get(item, 'studentMenu.selectedMenu')">{{ $_get(item, 'studentMenu.amount', 1) }}</div>
      </template>
      <template v-slot:[`item.realAteAmount`]="{ item }">
        <div>{{ $_get(item, 'mealTransfer.amount', 0) }}</div>
      </template>
      <template v-slot:[`item.note`]="{ item }">
        <div v-if="$_get(item, 'studentMenu.allergyNote')">{{ $_get(item, 'studentMenu.allergyNote') }}</div>
        <div v-if="$_get(item, 'studentMenu.otherNote')">{{ $_get(item, 'studentMenu.otherNote') }}</div>
      </template>
      <template v-slot:[`item.mealTransferStatus`]="{ item }">
        <v-chip small class="white--text" label :color="getStatusColor($_get(item, 'mealTransferStatus'))">
          <div class="white--text">{{ $_get(item, 'mealTransferStatus') | mealTransferStatus }}</div>
        </v-chip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon :disabled="!$auth.policies['update-student-register']" @click="onEdit(item)">mdi-pencil</v-icon>
      </template>
    </v-data-table>
    <ChangeMenuRegisterDialog :state="editDialog" :item="selectedItem" @updated="refresh(studentMenuSearchParams)" />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'

const originHeaders = [
  {
    text: 'Học sinh',
    value: 'student',
    align: 'left',
    sortable: false
  },
  {
    text: 'Lớp',
    value: 'class',
    align: 'left',
    width: 100,
    sortable: false
  },
  {
    text: 'Ngày sinh',
    value: 'dob',
    align: 'left',
    sortable: false
  },
  {
    text: 'Đăng ký',
    value: 'selectedMenu',
    align: 'left',
    sortable: false
  },
  {
    text: 'SL đăng ký',
    value: 'registedAmount',
    align: 'left',
    sortable: false
  },
  {
    text: 'Ghi chú của phụ huynh',
    value: 'note',
    align: 'left',
    sortable: false
  },
  {
    text: 'Trạng thái',
    value: 'mealTransferStatus',
    align: 'left',
    sortable: false
  },
  {
    text: 'SL ăn thực tế',
    value: 'realAteAmount',
    align: 'left',
    sortable: false
  },
  {
    text: 'Thao tác',
    value: 'actions',
    align: 'left',
    sortable: false
  }
]

export default {
  components: {
    CardStudentName,
    ChangeMenuRegisterDialog: () => import('@/modules/studentMenuRegister/ChangeMenuRegisterDialog.vue')
  },
  props: {},
  data() {
    return {
      headers: originHeaders,
      tableOptions: {},
      editDialog: false,
      selectedItem: {},
      selectedStudent: {}
    }
  },
  async created() {},
  methods: {
    ...mapActions('StudentMenuRegister', ['getMenuRegisterByStudents', 'removeStudentMenu']),
    async refresh(query) {
      query = query || {}
      this.getMenuRegisterByStudents(query)
    },
    onEdit(item) {
      this.editDialog = !this.editDialog
      this.selectedItem = item
    },
    getStatusSelectedMenu(type) {
      switch (type) {
        case 'menu1':
          return '#46BE8A'
        case 'menu2':
          return '#46BE8A'
        case '0':
          return '#F4BB43'
        default:
          return '#D3D3D3'
      }
    },
    getStatusColor(type) {
      switch (type) {
        case 'ate':
          return '#46BE8A'
        case 'not-eat':
          return '#D3D3D3'
        case 'not-receive':
          return 'error'
        default:
          return 'grey'
      }
    }
  },
  computed: {
    ...mapState('StudentMenuRegister', ['studentMenus', 'totalItems', 'pageText', 'loading', 'studentMenuSearchParams'])
  },
  watch: {}
}
</script>

<style lang="scss" scoped></style>
